// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalButton__button___nNS8O {
    --modal-button-small-height: 4rem;
    --modal-button-small-width: 9.6rem;
    --modal-button-expanded-height: 46rem;
    --modal-button-expanded-width: 32rem;

    cursor: unset;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;

    display: flex;
    flex-direction: column;

    width: var(--modal-button-small-width);
    height: var(--modal-button-small-height);

    border: var(--control-border-width) solid var(--color-bg-border);
    border-radius: calc(var(--control-radius) * 2);
    box-shadow: var(--shadow-layer);

    transition: all var(--geomate-time-duration) var(--geomate-time-function);

    &.ModalButton__expanded___VJPrt {
        width: var(--modal-button-expanded-width);
        height: var(--modal-button-expanded-height);
    }
}

.ModalButton__header___hOZZD {
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;

    display: flex;
    gap: var(--space-xs);

    padding: var(--space-xs) var(--space-s);

    &.ModalButton__expanded___VJPrt {
        cursor: unset;
    }

    & .ModalButton__closeButton___HqYvv {
        margin-left: auto;
    }
}

.ModalButton__content___tlqGx {
    overflow: hidden;
    display: block;
    height: 100%;
    transition: all var(--geomate-time-duration);

    &.ModalButton__hidden___lN1Oy {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/ModalButton/ModalButton.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,qCAAqC;IACrC,oCAAoC;;IAEpC,aAAa;IACb,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,sBAAsB;;IAEtB,sCAAsC;IACtC,wCAAwC;;IAExC,gEAAgE;IAChE,8CAA8C;IAC9C,+BAA+B;;IAE/B,yEAAyE;;IAEzE;QACI,yCAAyC;QACzC,2CAA2C;IAC/C;AACJ;;AAEA;IACI,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,oBAAoB;;IAEpB,uCAAuC;;IAEvC;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,4CAA4C;;IAE5C;QACI,aAAa;IACjB;AACJ","sourcesContent":[".button {\n    --modal-button-small-height: 4rem;\n    --modal-button-small-width: 9.6rem;\n    --modal-button-expanded-height: 46rem;\n    --modal-button-expanded-width: 32rem;\n\n    cursor: unset;\n    user-select: none;\n\n    display: flex;\n    flex-direction: column;\n\n    width: var(--modal-button-small-width);\n    height: var(--modal-button-small-height);\n\n    border: var(--control-border-width) solid var(--color-bg-border);\n    border-radius: calc(var(--control-radius) * 2);\n    box-shadow: var(--shadow-layer);\n\n    transition: all var(--geomate-time-duration) var(--geomate-time-function);\n\n    &.expanded {\n        width: var(--modal-button-expanded-width);\n        height: var(--modal-button-expanded-height);\n    }\n}\n\n.header {\n    cursor: pointer;\n    user-select: none;\n\n    display: flex;\n    gap: var(--space-xs);\n\n    padding: var(--space-xs) var(--space-s);\n\n    &.expanded {\n        cursor: unset;\n    }\n\n    & .closeButton {\n        margin-left: auto;\n    }\n}\n\n.content {\n    overflow: hidden;\n    display: block;\n    height: 100%;\n    transition: all var(--geomate-time-duration);\n\n    &.hidden {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ModalButton__button___nNS8O`,
	"expanded": `ModalButton__expanded___VJPrt`,
	"header": `ModalButton__header___hOZZD`,
	"closeButton": `ModalButton__closeButton___HqYvv`,
	"content": `ModalButton__content___tlqGx`,
	"hidden": `ModalButton__hidden___lN1Oy`
};
export default ___CSS_LOADER_EXPORT___;
